import { API } from 'data';
import { RestAPI } from 'scripts';
import { PostType } from 'types';

export function __FetchRelatedPosts(slug: string) {
    return new Promise<PostType<'list'>[]>((resolve, reject) => {
        RestAPI.get<PostType<'list'>[]>(API.posts.otherOwnerApprovedList(slug))
            .then((res) => resolve(res.data))
            .catch(reject);
    });
}
